import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class OnboardingConfirmationService {

    constructor(
        private http: HttpClient
    ) { }

    resendEmail(code) {
        return this.http.get(environment.serverUrl + '/team/selfonboard/resendInvitation/' + code);
    }

}



// WEBPACK FOOTER //
// ./src/app/onboarding-confirmation/onboarding-confirmation.service.ts